import { Notify } from 'quasar'

Notify.setDefaults({
  color: 'positive',
  position: 'bottom',
  timeout: 3500,
  textColor: 'white',
  actions: [{ icon: 'close', color: 'white' }]
})
